import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Card, CardContent, CardMedia, Typography, IconButton, Icon } from '@material-ui/core';
import AmexIcon from '../../../assets/images/american-express-1.png';
import CreditCardIcon from '../../../assets/images/credit-card.svg';
import GiftCardIcon from '../../../assets/images/primary_logo.svg';
import MasterIcon from '../../../assets/images/master.svg';
import VisaIcon from '../../../assets/images/visa.svg';

import '../../../css/paymentMethodPage/subComponents/PaymentMethodComponent.scss';

class PaymentMethodComponent extends Component {
  onClickDelete = () => {
    const { paymentOption, onClickDelete } = this.props;
    onClickDelete(paymentOption);
  }

  getImage = () => {
    const { paymentOption } = this.props;
    switch (paymentOption.cardType.toLowerCase()) {
      case 'amex':
        return AmexIcon;
      case 'gift_card':
        return GiftCardIcon;
      case 'mastercard':
        return MasterIcon;
      case 'visa':
        return VisaIcon;
      default:
        return CreditCardIcon;
    }
  }

  render() {
    const { paymentOption, translation } = this.props;
    return (
      <Card
        key={paymentOption.id}
        className="paymentMethodComponent-card"
      >
        <CardContent className="paymentMethodComponent-cardContent">
          <CardMedia
            component="img"
            src={this.getImage()}
            className="paymentMethodComponent-cardImage"
          />
          <div className="paymentMethodComponent-cardInfo" >
            <Typography className="paymentMethodComponent-cardNumber">{paymentOption.cardNumber}</Typography>
            <Typography className="paymentMethodComponent-expiryDate ">{`${translation('PaymentMethodPage.expire')} ${paymentOption.expiryDate}`}</Typography>
          </div>
          <IconButton
            className="paymentMethodComponent-iconButton"
            onClick={this.onClickDelete}
          >
            <Icon className="paymentMethodComponent-icon">delete</Icon>
          </IconButton>
        </CardContent>
      </Card>
    );
  }
}

PaymentMethodComponent.propTypes = {
  translation: PropTypes.func.isRequired,
  paymentOption: PropTypes.objectOf(PropTypes.any),
  onClickDelete: PropTypes.func,
};

PaymentMethodComponent.defaultProps = {
  paymentOption: null,
  onClickDelete: () => {},
};

export default (withRouter(PaymentMethodComponent));
